import React, { Fragment } from 'react'
import { Link } from 'react-router'
import { JUKE_PATH, ACTIVITY_DIY_PATH } from '@constant'

export default store => [
  {
    title: '申请时间',
    dataIndex: 'created_at',
    key: 'created_at'
  },
  {
    title: '活动名称',
    dataIndex: 'title',
    key: 'title',
    width: 400
  },
  {
    title: '封面图',
    dataIndex: 'list_img',
    key: 'list_img',
    render: list_img =>
      list_img && (
        <img
          src={`${
            list_img.indexOf('?imageMogr2') > -1
              ? list_img + '/thumbnail/!108'
              : list_img + '?imageView2/1/w/108/h/68'
          }`}
        />
      )
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    render: status => (
      <Fragment>
        {(status == 0 || status == 3) && <p>审核中</p>}
        {status == 1 && (
          <div style={{ color: '#80d089' }}>
            <p>审核通过</p>
            <p>（即将上线）</p>
          </div>
        )}
        {status == 2 && <p style={{ color: '#ff705e' }}>审核不通过</p>}
      </Fragment>
    )
  },
  {
    title: '操作',
    key: 'action',
    render: ({ status, id, activity_from, activity_link, title }) => {
      return (
        <Fragment>
          {activity_from == '1' ? (
            status == 2 ? (
              <Link to={ACTIVITY_DIY_PATH}>修改活动</Link>
            ) : (
              <Link
                onClick={() => {
                  window.open(
                    activity_link,
                    title,
                    `height=667, width=375, top=${(window.screen.height - 667) /
                      2},left=${(window.screen.width - 375) / 2}`
                  )
                }}
              >
                查看详情
              </Link>
            )
          ) : (
            <Link to={`${JUKE_PATH}/view/${id}`}>查看详情</Link>
          )}
        </Fragment>
      )
    }
  }
]
